// Build the address text to save from a Google Places result, keeping venue names
// (e.g. "The Lowry Hotel, 50 Dearmans Pl, Salford M3 5LH, UK").
export const placeLabel = (place, fallback = '') => {
  if (!place) return fallback;
  const addr = place.formatted_address || '';
  const name = (place.name || '').trim();
  if (!addr) return name || fallback;
  const isStreetOnly = !name || /^\d/.test(name) || addr.toLowerCase().startsWith(name.toLowerCase());
  return isStreetOnly ? addr : `${name}, ${addr}`;
};
